import { execFile } from 'node:child_process'
import { promisify } from 'node:util'
import { existsSync } from 'node:fs'
import { homedir } from 'node:os'
import { join } from 'node:path'

const execFileAsync = promisify(execFile)

export function getDefaultUvPath(): string {
  const home = homedir()
  if (process.platform === 'win32') {
    return join(home, '.local', 'bin', 'uv.exe')
  }
  return join(home, '.local', 'bin', 'uv')
}

export function getDefaultUvxPath(): string {
  const home = homedir()
  if (process.platform === 'win32') {
    return join(home, '.local', 'bin', 'uvx.exe')
  }
  return join(home, '.local', 'bin', 'uvx')
}

async function installUv(): Promise<void> {
  const uvInstallDir = join(homedir(), '.local', 'bin')

  if (process.platform === 'win32') {
    await execFileAsync(
      'powershell',
      [
        '-ExecutionPolicy',
        'ByPass',
        '-c',
        `$env:UV_INSTALL_DIR="${uvInstallDir}"; $env:UV_NO_MODIFY_PATH=1; irm https://astral.sh/uv/install.ps1 | iex`,
      ],
      { timeout: 60_000 },
    )
  } else {
    await execFileAsync(
      'sh',
      [
        '-c',
        `UV_INSTALL_DIR="${uvInstallDir}" UV_NO_MODIFY_PATH=1 curl -LsSf https://astral.sh/uv/install.sh | sh`,
      ],
      { timeout: 60_000 },
    )
  }
}

export async function findOrInstallUv(): Promise<string> {
  const defaultPath = getDefaultUvPath()
  if (existsSync(defaultPath)) {
    return defaultPath
  }
  await installUv()
  if (existsSync(defaultPath)) {
    return defaultPath
  }
  throw new Error(`uv binary not found at ${defaultPath} after installation`)
}
